import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { pushState } from 'redux-router';
import { Link } from 'react-router';
import OrganizationCard from '../OrganizationCard';
import OrganizationsPagination from '../OrganizationsPagination';

export default class BFWLps extends React.Component {
  constructor(props) {
    super(props);
  }


  previousPage = e => {
    e.preventDefault();
    const { previous, count, limit, offset } = this.props.bfwOrgs;
    if(previous) {
      this.props.loadBFWOrganizations({
        is_bfw_lp: true,
        limit: limit,
        offset: offset - limit
      });
    }
  }

  nextPage = (e) => {
    e.preventDefault();
    const { next, limit, offset, count } = this.props.bfwOrgs;
    if(next) {
      this.props.loadBFWOrganizations({
        is_bfw_lp: true,
        limit: limit,
        offset: offset + limit
      });
    }
  }

  pageJump = (number, e) => {
    const { count, limit, offset } = this.props.bfwOrgs;
    const maxOffset =  count - limit;
    let newOffset = number * limit - 10;
    if(newOffset > maxOffset) {
      newOffset = maxOffset;
    }

    this.props.loadBFWOrganizations({
      is_bfw_lp: true,
      limit: limit,
      offset: newOffset
    });
  }

  render() {

    if (!this.props.bfwOrgs) {
      return <span />;
    }

    let bfwOrgs = this.props.bfwOrgs;
    let user = this.props.user;

    let bfwOrgList = bfwOrgs.results.map((org) => {
      return <OrganizationCard user={user} key={org.id} item={org} db_id={org.id} />;
    });

    let bfwPagination = (
      <OrganizationsPagination organizations={bfwOrgs}
                               pageJump={this.pageJump}
                               nextPage={this.nextPage}
                               previousPage={this.previousPage} />
    );

    return(
      <div>
        <div className="buyFromWomen-header">
          <h4>Take a look at our inaugural women-owned businesses!</h4>
          {bfwPagination}
        </div>
        <div className="categoryDetail-organizationsListContainer">
          {bfwOrgList}
        </div>
        <div style={{marginTop: '1.0rem'}}>
          {bfwPagination}
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/buyFromWomen/BFWLps.jsx